/* Product video: plays muted (captions are burned in) while on screen, full playback with sound on request. */
if (!customElements.get('video-demo')) {
  customElements.define(
    'video-demo',
    class VideoDemo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.soundButton = this.querySelector('[data-play-sound]');
        this.endCard = this.querySelector('[data-end-card]');
        this.section = this.closest('.video-demo') || this;
        this.withSound = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.saveData = navigator.connection && navigator.connection.saveData;

        this.soundButton?.addEventListener('click', () => this.playWithSound(0, 'button'));
        this.querySelector('[data-replay]')?.addEventListener('click', () => this.playWithSound(0, 'replay'));
        this.section.querySelectorAll('[data-seek]').forEach((button) => {
          button.addEventListener('click', () => {
            this.playWithSound(Number(button.dataset.seek) || 0, 'chapter');
            if (window.matchMedia('(max-width: 749px)').matches) {
              this.scrollIntoView({ behavior: this.reducedMotion ? 'auto' : 'smooth', block: 'center' });
            }
          });
        });
        this.section.querySelectorAll('[data-demo-cta]').forEach((link) =>
          link.addEventListener('click', () => this.publish('demo_video_cta_clicked', { position: link.dataset.demoCta }))
        );
        this.video.addEventListener('ended', () => this.onEnded());
        this.video.addEventListener('timeupdate', () => this.trackProgress());

        this.observer = new IntersectionObserver((entries) => entries.forEach((entry) => this.onVisibility(entry)), {
          threshold: [0, 0.4],
        });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      onVisibility(entry) {
        const visible = entry.isIntersecting && entry.intersectionRatio >= 0.4;
        if (!visible) {
          if (!this.video.paused) this.video.pause();
          return;
        }
        if (this.withSound) return; // the visitor is in control once they chose sound
        if (this.reducedMotion || this.saveData || document.visibilityState !== 'visible') return;
        this.startPreview();
      }

      startPreview() {
        this.video.muted = true;
        this.video.loop = true;
        if (this.video.preload !== 'auto') this.video.preload = 'auto';
        const attempt = this.video.play();
        if (attempt && attempt.then) {
          attempt
            .then(() => {
              if (!this.previewStarted) {
                this.previewStarted = true;
                this.publish('demo_video_preview_started', {});
              }
            })
            .catch(() => {});
        }
      }

      playWithSound(time, source) {
        this.withSound = true;
        this.classList.add('is-playing-with-sound');
        if (this.endCard) this.endCard.hidden = true;
        if (this.soundButton) this.soundButton.hidden = true;
        this.video.loop = false;
        this.video.muted = false;
        this.video.controls = true;
        this.video.preload = 'auto';
        try {
          this.video.currentTime = time;
        } catch (e) {
          /* not seekable yet; starts from the beginning */
        }
        this.video.play().catch(() => {});
        this.publish('demo_video_sound_on', { source, from_second: time });
      }

      trackProgress() {
        if (!this.withSound || !this.video.duration) return;
        const pct = this.video.currentTime / this.video.duration;
        [0.5, 0.9].forEach((mark) => {
          if (pct >= mark && !(this.marks || (this.marks = new Set())).has(mark)) {
            this.marks.add(mark);
            this.publish('demo_video_progress', { percent: mark * 100 });
          }
        });
      }

      onEnded() {
        if (!this.withSound) return;
        this.video.controls = false;
        if (this.endCard) {
          this.endCard.hidden = false;
          this.endCard.querySelector('a, button')?.focus({ preventScroll: true });
        }
        this.publish('demo_video_completed', {});
      }

      publish(name, data) {
        try {
          if (window.emailSignup && typeof window.emailSignup.publish === 'function') {
            window.emailSignup.publish(name, data);
          } else if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
            Shopify.analytics.publish(name, data);
          }
        } catch (e) {
          /* analytics must never break the page */
        }
      }
    }
  );
}
